import { ChatUserCategory } from '@/constants';
import cloudService from './cloud';
import qbotService from './qbot';
import { getUserCategory } from '../util';

/**
 * 不同渠道使用不同的接口链路
 */
const service = getUserCategory() === ChatUserCategory.PHONE_NUMBER ? qbotService : cloudService;

export default service;



// WEBPACK FOOTER //
// ./src/utils/ajax/index.js